export const booksFeatures = {
    ALL: "all",
    EVENTS: 'events',
    TASKS: 'tasks',
    PROCESSES: 'processes',
    DECISION_TABLES: 'decisionTables',
    RULES: 'rules',
    REPORTS: 'reports',
    BOARDS: 'boards',
};
